/**
 * Internal dependencies
 */
import { createAction } from '../action-creators';
import { RootState } from '../types';
import { SET_FAQ_ITEMS } from '../actionTypes';

export const setFaqItems =
	createAction<RootState['faq']['items']>(SET_FAQ_ITEMS);
